import React from "react";
import Card from "react-bootstrap/Card";
import { ImBlogger, ImBook, ImLibrary } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Zion Le </span>
            from <span className="purple"> Ho Chi Minh City, Vietnam.</span>
            <br />
            I am currently working as a software engineer as freelancer and on-site in Ho Chi Minh City, Vietnam.
            <br />
            I have completed Computer Science and Engineering at University.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImLibrary /> 
              <span>Trading and Investing</span>
            </li>
            <li className="about-activity">
              <ImBlogger /> 
              <span>Writing Tech Blogs</span>
            </li>
            <li className="about-activity">
              <ImBook /> 
              <span>Reading Books</span>
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          {/* <footer className="blockquote-footer">Zion Le</footer> */}
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
